<template>
  <div class="content-loader">
    <div class="loader"></div>
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
  export default {
    name: 'ContentLoader',
    props: {
      title: {
        type: String,
        default: 'Пожалуйста, подождите, мы загружаем данные'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ContentLoader.vue